<script lang="ts">
  export let title: string;
  export let subtitle: string | null = null;
</script>

<style>
  .title {
    font-weight: 400;
    color: #141414;
    margin-bottom: 0.75em;
    font-size: 1.25em;
  }

  .subtitle {
    font-weight: 300;
    color: #141414;
    font-size: 0.75em;
  }

  .data {
    margin-top: 1.5em;
  }
</style>

<main>
  <div>
    <div class="title">{title}</div>
    {#if subtitle}
      <div class="subtitle">{subtitle}</div>
    {/if}
    <div class="data">
      <slot />
    </div>
  </div>
</main>
